import React, { FC, useEffect } from 'react'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { OnboardingPasswordDto } from '@sparling/financial-common'
import { FormProvider, useForm } from 'react-hook-form'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { CInputField } from '../CustomInputs/CInputField'
import { InputFieldPassword } from '../CustomInputs/InputFieldPassword'
import { GreenButton } from '../Buttons/GreenButton'

const resolver = classValidatorResolver(OnboardingPasswordDto)

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: 1184,
    margin: '0 auto',
  },
  titleContainer: {
    position: 'relative',
    paddingTop: 150,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formContainer: {
    width: '632px',
    paddingTop: theme.spacing(10),
  },
  inputWrap: {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  title: {
    padding: '25px 0',
    marginTop: '0 auto',
    fontSize: 40,
    fontWeight: 'bold',
    letterSpacing: 0,
    color: theme.palette.primary.dark,
  },
}))

interface IProps {
  model: OnboardingPasswordDto
  onSubmit: (newValue: unknown) => void
}

export const ResetPasswordComponent: FC<IProps> = (props): JSX.Element => {
  const classes = useStyles()
  const { model, onSubmit } = props
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
    resolver,
  })
  const { formState, setValue } = formMethods
  const { isValid } = formState

  useEffect(() => {
    setValue('firstName', model.firstName)
    setValue('lastName', model.lastName)
    setValue('email', model.email)
    setValue('password', '')
    setValue('confirmPassword', '')
  }, [model.email, model.firstName, model.lastName, setValue])

  return (
    <>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)} className={classes.form}>
          <Grid className={classes.container} container direction="column" alignItems="center">
            <Grid className={classes.titleContainer} container justifyContent={'center'} alignItems={'center'}>
              <Typography variant="h1" gutterBottom className={classes.title}>
                Reset Password
              </Typography>
            </Grid>
            <Grid container item className={classes.formContainer} direction={'column'}>
              <Grid container className={classes.inputWrap}>
                <CInputField name={'firstName'} label={'First Name'} />
                <CInputField name={'lastName'} label={'Last Name'} />
              </Grid>
              <Grid container className={classes.inputWrap}>
                <CInputField name={'email'} label={'Email'} />
              </Grid>
              <Grid container className={classes.inputWrap}>
                <InputFieldPassword name={'password'} label={'New Password'} />
                <InputFieldPassword name={'confirmPassword'} label={'Confirm Password'} />
              </Grid>
            </Grid>
            <GreenButton disabled={!isValid} type="submit" width={320} mt={64} mb={247} text="Next" />
          </Grid>
        </form>
      </FormProvider>
    </>
  )
}
